import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Stack, Text, rem } from '@mantine/core';
import { SecuritySessionTable } from './SecuritySessionTable';
export const SecuritySession: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack gap={24}>
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={{
      base: 10,
      sm: 24
    }} className={gunterzBold.className}>
        {i18n._('Sessions')}
      </Text>

      <SecuritySessionTable />
    </Stack>;
};